import React from 'react'
import Project from '../assets/project.json'
import {motion} from 'framer-motion'
function Projects() {
  return (
    <motion.div className='pt-10 ' 
    initial={{y:-100}}
    animate={{y:0}}>
     <div className=''>
        <h1 className='text-3xl text-gray-400 pb-3 text-center'> some of my Projects 🚀❤  </h1>

     </div>

     <div className='flex  justify-around shadow-md w-full cursor-pointer my-5 flex-wrap  '>

     {Project.map((pro)=>(

      <div className='flex flex-col max-w-sm shadow-xl cursor-pointer p-5'  key={pro.id}>
        <div className='' >

          
              <img className='w-full h-60 rounded-lg hover:-translate-y-4
            duration-100' src={pro.image} alt="" />
              <h1 className='text-gray-400 font-medium text-lg' >{pro.title}</h1>
        </div>
        <div className='space-y-2  '>
          <h5 className='text-start text-sm text-gray-500 '> {pro.description} </h5>
          <div className='space-x-2 text-white  ' >
            <button className='bg-gray-500 p-1 rounded-md '>
              <a href={pro.link}> Github</a>
            </button >
            <button className='bg-red-700 p-1 rounded-md'>
               <a href={pro.live}> Live</a>

            </button>
          
            
            
          </div>
           <div className='flex space-x-3 m-2 text-sm items-center '>
            <h1 className='p-1 text-white bg-slate-400 rounded-lg'> { pro.tech[0]}</h1>
            <h1 className='p-1 text-white bg-slate-400 rounded-lg'> { pro.tech[1]}</h1>
            <h1 className='p-1 text-white bg-slate-400 rounded-lg'> { pro.tech[2]}</h1>
            <h1 className='p-1 text-white bg-slate-400 rounded-lg'> { pro.tech[3]}</h1>
           </div>
        </div>
      </div>

     ))}
     </div>
    </motion.div>
  )
}

export default Projects
